import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const PhotoflipperModalLoader = lazyLoad({
  loader: () => import(/* webpackChunkName: "photoflipper-vdp-modal" */ './photoflipper-vdp-modal'),
  componentName: 'PhotoflipperVdpModal',
});
